import React from 'react';

import { getIsXfiPodDevice } from '../helpers/order';
import DefaultDeviceImage from './DefaultDeviceImage';
import DeviceImage from './DeviceImage';
import DeviceObjectSummary from './DeviceObjectSummary';

const DeviceObject = ({
  device,
  showSummary,
  returnInitiation,
}) => {
  let image = device.image && device.image.webImageLarge;

  if (getIsXfiPodDevice(device)) {
    image = 'https://static.cimcontent.net/common-web-assets/devices/xfi_pod-200.png';
  }
  return (
    <div className="device-object">
      <div className="device-object__image">
        {image && <DeviceImage device={device} />}
        {!image && <DefaultDeviceImage deviceType={device.deviceType} />}
      </div>
      <div className="device-object__content">
        <div className="hgroup">
          <h3>{device.title}</h3>
          {showSummary && (
            <DeviceObjectSummary
              {...{
                device,
                returnInitiation,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DeviceObject;
